import React from 'react';
import styles from './Layout.module.scss';
import { Button, ButtonStyles } from '../';
import { HashLink } from 'react-router-hash-link';
import { AiOutlineHome } from 'react-icons/ai';
import { VscFilePdf } from 'react-icons/vsc';
import resumePdfUrl from './BurakBalResume.pdf';

const ButtonClasses = `${ButtonStyles.buttonLight} ${ButtonStyles.buttonUnderline} ${ButtonStyles.buttonTertiary}`;
const scroll = (e) => {
    e.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

export const Header = () => {
    return (
        <header className={`${styles.header} no-print`} data-testid='pageHeader'>
            <div className={styles.headerLeft}>
                <HashLink to='/#summary' scroll={scroll}>
                    <AiOutlineHome className={styles.homeButton} />
                </HashLink>
            </div>
            <div className={styles.headerCenter} />
            <div className={styles.headerRight}>
                <Button
                    as='a'
                    className={[ButtonClasses, ButtonStyles.buttonCenter].join(' ')}
                    download='Burak Bal Resume.pdf'
                    href={resumePdfUrl}
                    title='Download the resume as a PDF'
                >
                    <span>Download PDF</span>
                    <VscFilePdf aria-hidden='true' />
                </Button>
            </div>
        </header>
    );
};
